import Button from '@mui/material/Button';
import TurnDisabledIcon from '@mui/icons-material/LockOutlined';
import { useTurnEnable } from '~/hooks/api/useTurnEnable';
import { FormattedMessage } from 'react-intl';
import { useQueryClient } from '@tanstack/react-query';
import messages from '../messages';

type DisableTurnButtonProps = {
  turnId: number;
  shiftId: number;
};

const DisableTurnButton = (props: DisableTurnButtonProps) => {
  const queryClient = useQueryClient();
  const mutation = useTurnEnable({
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['shifts', props.shiftId] });
    },
  });
  return (
    <Button
      color="inherit"
      onClick={() => {
        mutation.mutate({
          enable: 'false',
          turnId: props.turnId,
        });
      }}
      startIcon={<TurnDisabledIcon />}
      data-test="disable-turn-button"
    >
      {mutation.isPending ? (
        <FormattedMessage {...messages.disablingTurn} />
      ) : (
        <FormattedMessage {...messages.disableTurn} />
      )}
    </Button>
  );
};

export default DisableTurnButton;
